import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivContractControllerCreatePayloadGen,
  MrfiktivContractControllerGetParamsGen,
  MrfiktivContractControllerUpdatePayloadGen,
  MrfiktivContractSummaryViewModelGen,
  MrfiktivContractViewModelGen,
  MrfiktivMultipleIdsDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivWorkshopContractViewModelGen
} from "../v1/data-contracts";
import { Contract } from "../v1/Contract";

/**
 * Communicate with contract API
 */
class ContractService {
  mrfiktivProxy: Contract;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new Contract(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create ancontract
   */
  async create(
    partnerId: string,
    data: MrfiktivContractControllerCreatePayloadGen
  ): Promise<MrfiktivContractViewModelGen | MrfiktivWorkshopContractViewModelGen> {
    const contract = (await this.mrfiktivProxy.contractControllerCreate(partnerId, data)).data;

    return contract;
  }

  /**
   * Get allcontract
   */
  async get(
    data: MrfiktivContractControllerGetParamsGen
  ): Promise<
    MrfiktivPageViewModelGen & { data?: (MrfiktivContractViewModelGen | MrfiktivWorkshopContractViewModelGen)[] }
  > {
    const contracts = (await this.mrfiktivProxy.contractControllerGet(data)).data;

    return contracts;
  }

  /**
   * Get a contract
   */
  async getOne(
    partnerId: string,
    contractId: string
  ): Promise<MrfiktivContractViewModelGen | MrfiktivWorkshopContractViewModelGen> {
    const contract = (await this.mrfiktivProxy.contractControllerGetOne(partnerId, contractId)).data;

    return contract;
  }

  /**
   * Get many by contract ids
   */
  async getMany(partnerId: string, data: MrfiktivMultipleIdsDtoGen) {
    const companies = (await this.mrfiktivProxy.contractControllerGetMany(partnerId, data)).data;

    return companies;
  }

  /**
   * Get all contracts for multiple companies
   */
  async getManyByCompanyIds(partnerId: string, data: MrfiktivMultipleIdsDtoGen) {
    const companies = (await this.mrfiktivProxy.contractControllerGetManyByCompanyIds(partnerId, data)).data;

    return companies;
  }

  /**
   * Get all contracts for multiple companies
   */
  async getManyByRefIds(partnerId: string, data: MrfiktivMultipleIdsDtoGen) {
    const companies = (await this.mrfiktivProxy.contractControllerGetManyByRefIds(partnerId, data)).data;

    return companies;
  }

  /**
   * Update acontract
   */
  async update(
    partnerId: string,
    contractId: string,
    data: MrfiktivContractControllerUpdatePayloadGen
  ): Promise<MrfiktivContractViewModelGen | MrfiktivWorkshopContractViewModelGen> {
    const contract = (await this.mrfiktivProxy.contractControllerUpdate(partnerId, contractId, data)).data;

    return contract;
  }

  /**
   * Delete acontract
   */
  async delete(
    partnerId: string,
    contractId: string
  ): Promise<MrfiktivContractViewModelGen | MrfiktivWorkshopContractViewModelGen> {
    const contract = (await this.mrfiktivProxy.contractControllerDelete(partnerId, contractId)).data;

    return contract;
  }

  /**
   * Get the summary of a contract
   */
  async getSummary(partnerId: string, contractId: string): Promise<MrfiktivContractSummaryViewModelGen> {
    const summary = (await this.mrfiktivProxy.contractControllerGetSummary(partnerId, contractId)).data;

    return summary;
  }

  /**
   * Trigger generation of the contract summary
   */
  async summarize(partnerId: string, contractId: string): Promise<MrfiktivContractSummaryViewModelGen> {
    const summary = (await this.mrfiktivProxy.contractControllerSummarize(partnerId, contractId)).data;

    return summary;
  }
}

/**
 * Communicate withcontract API
 */
export default new ContractService(new MrfiktivHttpClientProvider());
